import { compose, prop } from 'ramda';

import { success } from 'app/features/success/selectors';

const heroBlock = compose(prop('heroBlock'), success);
const titleKey = compose(prop('titleKey'), heroBlock);
const subtitleKey = compose(prop('subtitleKey'), heroBlock);

export { titleKey, subtitleKey };
